/**
 * @see https://umijs.org/docs/max/access#access
 */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const perms = currentUser?.permissions || [];
  const isSuperAdmin = currentUser?.isSuperAdmin || false;

  const can = (key: string) => isSuperAdmin || perms.includes(key);

  return {
    canAdmin: !!currentUser && currentUser.access === 'admin',

    // Page-level
    canDashboard: can('dashboard:view'),
    canUsers: can('users:view'),
    canMiners: can('miners:view'),
    canFarms: can('farms:view'),
    canOrders: can('orders:view'),
    canTickets: can('tickets:view'),
    canWithdrawals: can('withdrawals:view'),
    canActivities: can('activities:view'),
    canAnalytics: can('analytics:view'),
    canChannels: can('channels:view'),
    canPayments: can('payments:view'),
    canReconciliation: can('reconciliation:view'),
    canTransactions: can('transactions:view'),
    canMessages: can('messages:view'),
    canSettings: can('settings:view'),
    canSystemAccounts: can('system:accounts'),
    canSystemRoles: can('system:roles'),

    // Button-level
    canDashboardEdit: can('dashboard:edit'),
    canUsersEdit: can('users:edit'),
    canUsersAdjustBalance: can('users:adjustBalance'),
    canUsersGrantMiner: can('users:grantMiner'),
    canMinersCreate: can('miners:create'),
    canMinersEdit: can('miners:edit'),
    canMinersDelete: can('miners:delete'),
    canFarmsCreate: can('farms:create'),
    canFarmsEdit: can('farms:edit'),
    canFarmsDelete: can('farms:delete'),
    canTicketsCreate: can('tickets:create'),
    canTicketsEdit: can('tickets:edit'),
    canTicketsDelete: can('tickets:delete'),
    canWithdrawalsApprove: can('withdrawals:approve'),
    canActivitiesManage: can('activities:manage'),
    canPaymentsManage: can('payments:manage'),
    canReconciliationManage: can('reconciliation:manage'),
    canMessagesSend: can('messages:send'),
    canMessagesDelete: can('messages:delete'),
    canSettingsEdit: can('settings:edit'),
  };
}
